import {Component, Inject, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from "@angular/material/bottom-sheet";
import moment from "moment";
import {
  ParceiroCompletarDadosService
} from "../../../modules/parceiro-completar-dados/service/parceiro-completar-dados.service";
import {AuthService} from "../../../core/auth/auth.service";
import {DeviceDetectorService} from "../../../core/services/device-detector.service";
import {DadosJwtService} from "../../../core/services/dados-jwt.service";

@Component({
  selector: 'app-modal-expiracao',
  templateUrl: './modal-expiracao.component.html',
  styleUrls: ['./modal-expiracao.component.scss']
})
export class ModalExpiracaoComponent {
  dataVencimento;
  parceiroId;
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public dataBottom,
    public dialogRef: MatDialogRef<ModalExpiracaoComponent>,
    private bottomSheetRef: MatBottomSheetRef<ModalExpiracaoComponent>,
    protected parceiroCompletarDadosService: ParceiroCompletarDadosService,
    public authService: AuthService,
    public dadosJwtService: DadosJwtService,
    public deviceDetectorService: DeviceDetectorService,
  ) {
    this.parceiroId = this.dadosJwtService.get().parceiroId;
    this.dataVencimento = parceiroCompletarDadosService.model.cabecalho.dataExpiracao;
  }

  continuarProcesso(): void {
    this.parceiroCompletarDadosService.continuarProcesso(this.parceiroId).subscribe(res => {
      if(!this.deviceDetectorService.isMobile()) {
        this.dialogRef.close()
      } else {
        this.bottomSheetRef.dismiss();
      }
    }, error => {

    })
  }
  protected readonly moment = moment;
}
